import { observable, action, runInAction } from "mobx";
import http from "../../util/http";
import _ from "lodash";

class InactiveList {
  @observable
  playerList = [];
  @observable
  term = "";
  @observable
  displayError = "";
  @observable
  newPlayer = {
    GlobalMaxPay: null,
    ReverseLimit: null,
    LiveCasinoWeeklyLimit: null,
    ReverseCountsDouble: null,
    Player: null,
    IdAgent: null,
    Agent: null,
    EZlive: null,
    CWSlive: null,
  };
  @observable
  hasDefault = false;
  @observable
  loading = false;
  @observable
  defaultValues = {
    GlobalMaxPay: 0,
    ReverseLimit: 0,
    LiveCasinoWeeklyLimit: 0,
    ReverseCountsDouble: false,
    Player: "DEFAULT",
    IdPlayer: null,
    IdAgent: null,
    Agent: null,
    EZlive: false,
    CWSlive: false,
  };
  emptyPlayer = _.clone(this.newPlayer);

  defaultNulls(vals) {
    return (
      _.get(vals, "GlobalMaxPay", "") === "" &&
      _.get(vals, "ReverseLimit", "") === "" &&
      _.get(vals, "LiveCasinoWeeklyLimit", "") === ""
    );
  }

  @action
  searchTerm(txt) {
    this.term = txt;
  }

  @action
  updateField(player, field, txt, isEdit) {
    if (isEdit) {
      const playerIndex = this.playerList.findIndex(
        (p) => p.IdPlayer === player.IdPlayer
      );
      this.playerList[playerIndex][field] = txt;
    } else {
      this.newPlayer[field] = txt;
    }
  }

  @action
  async getPlayertList() {
    try {
      runInAction(() => {
        this.loading = true;
      });
      /*const playerList = await http.sendCommand(
        "command:agent:agentConfig:getAgentList",
      );*/
      const playerList = await http.sendHelperCommand(
        "AgentConfigListHelper.aspx",
        { Term: this.term }
      );
      runInAction(() => {
        const defaultValues = _.find(playerList, { Player: "" });
        this.hasDefault = !_.isEmpty(defaultValues);
        this.playerList = playerList;

        if (!this.hasDefault || this.defaultNulls(defaultValues)) {
          this.defaultValues.Agent = playerList[0].Agent;
          this.defaultValues.IdAgent = playerList[0].IdAgent;
          this.playerList.unshift(this.defaultValues);
          if (this.defaultNulls(defaultValues)) {
            this.hasDefault = false;
            _.remove(this.playerList, (player) => player.Player === "");
          }
        } else {
          this.newPlayer = defaultValues;
        }
        this.loading = false;
      });
    } catch (err) {
      this.loading = false;
      this.displayError = `There is no agent list for ${this.term}, ${err.message}`;
    }
  }

  @action
  async deletePlayer(IdAgent, IdPlayer) {
    try {
      const payloadDelete = JSON.stringify({
        IdAgent,
        IdPlayer,
      });
      await http.sendHelperCommand("AgentConfigDeleteHelper.aspx", {
        payload: payloadDelete,
      });
      this.getPlayertList();
    } catch (err) {
      console.log(err);
    }
  }

  @action
  async editPlayer(player) {
    try {
      player.ReverseCountsDouble = _.includes(
        [true, "True", 1],
        player.ReverseCountsDouble
      )
        ? 1
        : 0;
      player.EZlive = _.includes([true, "True", 1], player.EZlive) ? 1 : 0;
      player.CWSlive = _.includes([true, "True", 1], player.CWSlive) ? 1 : 0;

      if (this.hasDefault === false) {
        this.createPlayer(player);
      } else {
        /*await http.sendCommand("command:agent:agentConfig:updatePlayer", {
          ...player
        });*/
        const payloadUpdate = JSON.stringify(player);
        await http.sendHelperCommand("AgentConfigUpdatePlayerHelper.aspx", {
          payload: payloadUpdate,
        });
      }
      runInAction(() => {
        this.newPlayer = this.emptyPlayer;
      });
      this.getPlayertList();
    } catch (err) {
      console.log(err);
    }
  }

  @action
  async createPlayer(player) {
    try {
      player.ReverseCountsDouble = _.includes(
        [true, "True", 1],
        player.ReverseCountsDouble
      )
        ? 1
        : 0;
      player.EZlive = _.includes([true, "True", 1], player.EZlive) ? 1 : 0;
      player.CWSlive = _.includes([true, "True", 1], player.CWSlive) ? 1 : 0;
      player.Agent = this.playerList[0].Agent;
      player.IdAgent = this.playerList[0].IdAgent;
      player.GlobalMaxPay = player.GlobalMaxPay ? player.GlobalMaxPay : 0;
      player.LiveCasinoWeeklyLimit = player.LiveCasinoWeeklyLimit
        ? player.LiveCasinoWeeklyLimit
        : 0;
      player.ReverseLimit = player.ReverseLimit ? player.ReverseLimit : 0;

      /*await http.sendCommand("command:agent:agentConfig:createPlayer", {
        ...player
      });*/
      const payloadCreate = JSON.stringify(player);
      await http.sendHelperCommand("AgentConfigCreatePlayerHelper.aspx", {
        payload: payloadCreate,
      });
      runInAction(() => {
        this.newPlayer = this.emptyPlayer;
      });
      this.getPlayertList();
    } catch (err) {
      console.log(err);
    }
  }
}

export default new InactiveList();
